<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-6">
                <div class="search-box mr-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <input
                      type="text"
                      class="form-control"
                      v-model="search"
                      placeholder="Buscar páginas..."
                      @keyup.enter="doSearch"
                    />
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="float-sm-end d-flex">
                  <div class="text-sm-right">
                    <button
                      type="button"
                      class="btn btn-success btn-rounded mb-2 mr-2"
                      @click="openEditor()"
                    >
                      <i class="mdi mdi-plus mr-1"></i> Nova Página de Obrigado
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <table class="table table-centered table-nowrap table-hover">
                <thead class="thead-light">
                  <tr>
                    <th width="40%">Nome</th>
                    <th width="20%">Forms Usando</th>
                    <th width="15%">Padrão</th>
                    <th width="10%">Status</th>
                    <th width="15%">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="page in pagesList" :key="page.id">
                    <td class="link" @click="openEditor(page.id)">
                      <h5 class="font-size-14 mb-1">
                        <span class="text-dark">
                          <i v-if="page.is_default" class="mdi mdi-star text-warning mr-1"></i>
                          {{ page.name }}
                        </span>
                      </h5>
                      <p class="text-muted mb-0" v-if="page.description">
                        {{ page.description | truncate(50) }}
                      </p>
                    </td>
                    <td>
                      <span class="badge badge-soft-info font-size-12">
                        {{ page.forms_count || 0 }} formulário(s)
                      </span>
                    </td>
                    <td>
                      <span
                        v-if="page.is_default"
                        class="badge badge-soft-warning font-size-12"
                      >
                        Sim
                      </span>
                      <button
                        v-else
                        type="button"
                        class="btn btn-sm btn-outline-warning"
                        @click="setAsDefault(page)"
                        title="Marcar como padrão"
                      >
                        Definir padrão
                      </button>
                    </td>
                    <td>
                      <span
                        class="badge font-size-12"
                        :class="page.status ? 'badge-soft-success' : 'badge-soft-danger'"
                        style="cursor: pointer"
                        @click="toggleStatus(page.id)"
                      >
                        {{ page.status ? 'Ativo' : 'Inativo' }}
                      </span>
                    </td>
                    <td>
                      <div class="btn-group">
                        <button
                          type="button"
                          class="btn btn-sm btn-outline-primary"
                          @click="openEditor(page.id)"
                          title="Editar"
                        >
                          <i class="bx bx-edit-alt"></i>
                        </button>
                        <button
                          type="button"
                          class="btn btn-sm btn-outline-danger"
                          @click="deletePage(page)"
                          title="Excluir"
                          :disabled="page.is_default"
                        >
                          <i class="bx bx-trash"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="pagesList.length === 0 && !loading">
                    <td colspan="5" class="text-center py-4">
                      <p class="text-muted mb-0">Nenhuma página de obrigado encontrada</p>
                    </td>
                  </tr>
                  <tr v-if="loading">
                    <td colspan="5" class="text-center py-4">
                      <div class="spinner-border text-primary" role="status">
                        <span class="sr-only">Carregando...</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                      @input="updateList"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Swal from 'sweetalert2'
import Layout from '@/components/layout/vertical'
import PageHeader from '@/components/page-header'
import appConfig from '@/app.config'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import { mapActions, mapState } from 'vuex'

export default {
  components: {
    Layout,
    PageHeader
  },
  name: 'ThankYouPagesIndex',
  page: {
    title: 'Páginas de Obrigado',
    meta: [
      {
        name: 'description',
        content: appConfig.description
      }
    ]
  },
  data () {
    return {
      search: '',
      currentPage: 1,
      perPage: 20,
      title: 'Páginas de Obrigado',
      items: [
        {
          text: 'Form Builder',
          to: '/form-builder'
        },
        {
          text: 'Páginas de Obrigado',
          active: true
        }
      ]
    }
  },
  filters: {
    truncate (value, length) {
      if (!value) return ''
      if (value.length <= length) return value
      return value.substring(0, length) + '...'
    }
  },
  mounted () {
    this.updateList()
  },
  computed: {
    ...mapState('thankYouPages', ['pages', 'loading']),
    pagesList () {
      return this.pages.data || []
    },
    rows () {
      return this.pages.meta?.total || 0
    }
  },
  methods: {
    ...mapActions('thankYouPages', {
      getPages: 'GetPages',
      deletePageAction: 'DeletePage',
      changeStatusAction: 'ChangeStatus',
      setAsDefaultAction: 'SetAsDefault'
    }),
    openEditor (id = null) {
      if (id) {
        this.$router.push({ name: 'form-builder-thank-you-pages-edit', params: { id } })
      } else {
        this.$router.push({ name: 'form-builder-thank-you-pages-new' })
      }
    },
    async toggleStatus (id) {
      try {
        await this.changeStatusAction(id)
        successMessage('Status atualizado com sucesso.', 2500)
        this.updateList()
      } catch (err) {
        console.error(err)
        errorMessage('Erro ao atualizar status: ' + (err.response?.data?.message || err.message))
      }
    },
    async setAsDefault (page) {
      Swal.fire({
        title: 'Definir como padrão?',
        html: `A página <b>${page.name}</b> será definida como padrão do sistema.`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#34c38f',
        cancelButtonColor: '#4a4848',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Sim, definir!'
      }).then(async (result) => {
        if (result.value) {
          try {
            const loader = this.$loading.show()
            await this.setAsDefaultAction(page.id)
            loader.hide()
            successMessage('Página definida como padrão com sucesso.', 2500)
            this.updateList()
          } catch (err) {
            console.error(err)
            errorMessage('Erro ao definir como padrão: ' + (err.response?.data?.message || err.message))
          }
        }
      })
    },
    deletePage (page) {
      if (page.is_default) {
        errorMessage('Não é possível excluir a página padrão do sistema.')
        return
      }

      Swal.fire({
        title: 'Você tem certeza?',
        html: `Será excluída a página: <b>${page.name}</b>`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#f46a6a',
        cancelButtonColor: '#4a4848',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Sim, excluir!'
      }).then(async (result) => {
        if (result.value) {
          try {
            await this.deletePageAction(page.id)
            successMessage('Página de obrigado excluída com sucesso.', 2500)
            this.updateList()
          } catch (err) {
            console.error(err)
            errorMessage('Erro ao excluir: ' + (err.response?.data?.message || err.message))
          }
        }
      })
    },
    doSearch () {
      this.currentPage = 1
      this.updateList()
    },
    updateList () {
      const params = {
        search: this.search || null,
        limit: this.perPage,
        page: this.currentPage
      }
      this.getPages(params).catch((error) => {
        console.error(error)
        errorMessage('Erro ao carregar páginas de obrigado: ' + (error.response?.data?.message || error.message))
      })
    }
  }
}
</script>

<style scoped>
.link {
  cursor: pointer;
}
.table-responsive {
  min-height: 300px;
}
.float-sm-end {
  float: right;
}
.btn-group .btn {
  margin-right: 2px;
}
</style>
